import MuiLink, { type LinkProps as MuiLinkProps } from '@mui/material/Link';
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router';

type LinkProps = MuiLinkProps & RouterLinkProps;

export const Link = ({ children, ...props }: LinkProps) => (
  <MuiLink component={RouterLink} {...props}>
    {children}
  </MuiLink>
);
